import React from 'react';
import type { ComponentType } from 'react';
import { render } from 'react-dom';

const APP_ROOT_ID = 'app';
const PROPS_SCRIPT_ID = 'app-props';

function readAppProps<T extends Record<string, unknown>>(): T {
  const el = document.getElementById(PROPS_SCRIPT_ID);
  if (!el?.textContent?.trim()) {
    return {} as T;
  }
  return JSON.parse(el.textContent) as T;
}

export function mountApp<P extends Record<string, unknown>>(
  Component: ComponentType<P>,
  props?: P,
): void {
  const mount = () => {
    const root = document.getElementById(APP_ROOT_ID);
    if (!root) return;

    const resolvedProps = props ?? readAppProps<P>();
    render(React.createElement(Component, resolvedProps), root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
}
